const initialState = {
  initials: [],
  createDocLoading: false,
  designProListState: [],
  projectContactListState: [],
  feeSimpleListState: [],
  bondingCompanyListState: [],
  mortgageLenderListState: [],
  submitDisabled: false,
  projectSubmitDisabled: false,
  feeSimpleSubmitDisabled: false,
  bondingSubmitDisabled: false,
  mortgageSubmitDisabled: false,
  addingNewDesignPro: false,
  addingNewProject: false,
  addingNewFeeSimple: false,
  addingNewBonding: false,
  addingNewMortgage: false,
  workDesc: "",
  createBuildingLoading: false,
  isCreatingBuilding: false,
  pdfSize: "letter",
  sizeChangedText: "",
  permissionLoading: false, //obtain permit
  isCreatingObtainPermit: false, //obtain permit
  isCreatingEnergy: false, // energy
  isCreatingAsbestos: false, // asbestos
  isCreatingRoofing: false, // roofing
  isCreatingOwnership: false, // ownership
  isCreatingForm: false, // permitform
  signersChanged: false, // permitform
  designProLoading: false,
  newProjectLoading: false,
  feeSimpleLoading: false,
  bondingLoading: false,
  mortgageLoading: false,
  canvasOpen: false,
  magnifierOn: false,
};

const buildingStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MAGNIFIER_ON":
      return {
        ...state,
        magnifierOn: action.payload,
      };
    case "SET_BUILDING_STATE":
      return {
        ...state,
        ...action.payload,
      };
    case "SET_BUILDING_LIST_STATES": {
      const { key, val } = action.payload;
      return {
        ...state,
        [key]: [...(state[key] || []), val],
      };
    }
    case "SET_BUILDING_LIST_STATES_FULL": {
      const { key, val, withID } = action.payload;
      const currentList = state[key] || [];

      if (withID) {
        const updatedList = Array.isArray(currentList)
          ? currentList.map((item) => (item?.id === val?.id ? val : item))
          : currentList;

        // If no matching ID was found, optionally push new one:
        const exists = currentList.some((item) => item?.id === val?.id);
        const finalList = exists ? updatedList : [...updatedList, val];

        return {
          ...state,
          [key]: finalList,
        };
      }

      //   // Fallback: full replacement
      //   if (JSON.stringify(currentList) === JSON.stringify(val)) {
      //     return state;
      //   }

      return {
        ...state,
        [key]: val,
      };
    }
    default:
      return state;
  }
};

export default buildingStateReducer;
